(() => {
  /*============================================================================
    Shop the look carousel
  ==============================================================================*/
  var ShopTheLook = function () {
    function ShopTheLook(element) {
      _classCallCheck(this, ShopTheLook);

      _initCarousel(element);

      _attachListeners(element);

      _initQuickSop(element);
    }

    function _initQuickSop(element) {

      window.QuickShop(element);
    }

    function _initCarousel(element) {
      var mainSlider = element.querySelector('.shop-the-look-carousel');

      var promises = [];
      element.querySelectorAll('.hotspot-carousel').forEach(elem => {
        promises.push(new Promise(function (resolve, reject) {
          new themeVendor.Flickity(elem, {
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            adaptiveHeight: false,

            selectedAttraction: 0.05,
            friction: 0.8,
            contain: false,
            on: {
              ready: function () {
                this.activate();
                resolve();
              },
              change: function (index) {
                var hotspot = element.querySelector('.product-features__hotspot[data-product-index="' + index + '"]');
                hotspot.parentElement.querySelectorAll('.product-features__hotspot').forEach(elem => {
                  elem.classList.remove('is-active');
                })

                hotspot.classList.add('is-active');
              }
            }
          });
        }));
      });

      Promise.all(promises).then(function AcceptHandler(results) {
        this.flkty = new themeVendor.Flickity(mainSlider, {
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
          adaptiveHeight: false,
          draggable: window.innerWidth > 767 ? false : true,
          cellAlign: 'left',

          contain: true,

          on: {
            ready: function () {
              setTimeout(() => {
                mainSlider.parentNode.dispatchEvent(
                  new CustomEvent('slider-is-loaded', {
                    bubbles: true,
                    detail: {
                      slider: { flkty: this },
                    },
                  })
                );
              }, 10);
            }
          }
        });

        this.flkty.activate();
      });

      element.querySelectorAll('[data-product-grid-item]').forEach((item) => {
        new window.theme.QuickAddProduct(item);
      });
    }

    function _attachListeners(element) {
      element.querySelectorAll('.product-features__hotspot').forEach((item) => {
        item.addEventListener('click', function (e) {
          if (window.innerWidth > 767) {
            const target = e.target;

            if (target.matches('.product-features__hotspot') || target.closest('.product-features__hotspot')) {
              e.preventDefault();

              let slideIdx = 0;
              let selector;
              if (target.matches('.product-features__hotspot')) {
                selector = target;
              } else {
                selector = target.closest('.product-features__hotspot');
              }

              slideIdx = parseInt(selector.getAttribute('data-product-index'));
              const slider = selector.closest('.product-features__wrapper').querySelector('.hotspot-carousel');
              const flkty = themeVendor.Flickity.data(slider);

              flkty.select(slideIdx);

              selector.parentElement.querySelectorAll('.product-features__hotspot').forEach(elem => {
                elem.classList.remove('is-active');
              })

              selector.classList.add('is-active');
            }
          }
        });
      });
    }

    _createClass(ShopTheLook, [{
      key: "onUnload",
      value: function onUnload() {
      }
    }]);

    return ShopTheLook;
  }();

  window.sections.register('shop-the-look', ShopTheLook);
})();